import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppComponent } from '../../app.component';
import { ApiService } from '../../services/api.service';
import { PermissionsService } from '../../services/permissions.service';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';


@Component({
  selector: 'app-bhasmaarti-dashboard',
  templateUrl: './bhasmaarti-dashboard.component.html',
  styleUrls: ['./bhasmaarti-dashboard.component.scss']
})
export class BhasmaartiDashboardComponent implements OnInit {


 public barChartOptions: any = {
  responsive: true,
    maintainAspectRatio: false,
  plugins: {
    datalabels: {
      anchor: 'end',
      align: 'top',
      font: {
        weight: 'bold',
        size: 12
      },
      color: '#000'
    }
  },
    animation: { duration: 600, easing: 'easeOutQuad' },
  scales: {
    xAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: 'Departments',
           fontSize: 14,
           fontStyle: 'bold'
        },
        ticks: {
          autoSkip: false,
          minRotation: 45,
           fontSize: 14,
        },
        gridLines: {
        display: false
      }
      }
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: 'Count (Quota / Visitor)',
           fontSize: 14,
           fontStyle: 'bold'
        },
        ticks: {
          beginAtZero: true,
           fontSize: 14,
        }
      }
    ]
  }
};

  public barChartPlugins = [pluginDataLabels];


  public barChartLabels = [];
  public barChartType = 'bar';
  public barChartLegend = false;

  public barChartData = [];

public originalData: any[] = [];
public selectedType: string = '';
public drillLevel = 1; // 1 = type, 2 = source, 3 = department
public selectedSource: string = '';


  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService

  ) {

    this.getList();
   }

  ngOnInit() {
  }

  getList() {
    this.appComponent.showLoader();
    this.apiService.getDataFromPublicServer(`/public/api/v1/visitor_stats?api_key=eyJhbGciOi-a67c-11eb-bcbc-0242bd160625`).subscribe(
      (res: any) => {
        this.appComponent.hideLoader();
        this.originalData = res.data.statistics;

      this.showTypeLevelChart();
      },
      err => {
        console.log(err);
      }
    );
  }


 showTypeLevelChart() {
  this.drillLevel = 1;
  const grouped = new Map();

  this.originalData.forEach(item => {
    const type = item.type;
    const existing = grouped.get(type) || { quota: 0, visitor_count: 0 };
    grouped.set(type, {
      quota: existing.quota + item.quota,
      visitor_count: existing.visitor_count + item.visitor_count
    });
  });

  const labels = Array.from(grouped.keys());
  const quotaData = labels.map(label => grouped.get(label).quota);
  const visitorData = labels.map(label => grouped.get(label).visitor_count);

  this.barChartLabels = labels;
  this.barChartData = [
    { data: quotaData, label: 'Quota' },
    { data: visitorData, label: 'Visitor Count' }
  ];
}

showSourceLevelChart(type: string) {
  this.drillLevel = 2;
  this.selectedType = type;

  const filtered = this.originalData.filter(item => item.type === type);
  const grouped = new Map();

  filtered.forEach(item => {
    const source = item.source;
    const existing = grouped.get(source) || { quota: 0, visitor_count: 0 };
    grouped.set(source, {
      quota: existing.quota + item.quota,
      visitor_count: existing.visitor_count + item.visitor_count
    });
  });

  const labels = Array.from(grouped.keys());
  const quotaData = labels.map(label => grouped.get(label).quota);
  const visitorData = labels.map(label => grouped.get(label).visitor_count);

  this.barChartLabels = labels;
  this.barChartData = [
    { data: quotaData, label: 'Quota' },
    { data: visitorData, label: 'Visitor Count' }
  ];
}

showDepartmentLevelChart(source: string) {
  this.drillLevel = 3;
  this.selectedSource = source;

  const filtered = this.originalData.filter(
    item => item.type === this.selectedType && item.source === source
  );

  const labels = filtered.map(item => item.department_name);
  const quotaData = filtered.map(item => item.quota);
  const visitorData = filtered.map(item => item.visitor_count);

  this.barChartLabels = labels;
  this.barChartData = [
    { data: quotaData, label: 'Quota' },
    { data: visitorData, label: 'Visitor Count' }
  ];
}

onChartClick(event: any): void {
  const activePoints = event.active;

  if (activePoints.length > 0) {
    const clickedIndex = activePoints[0]._index;
    const clickedLabel = this.barChartLabels[clickedIndex];

    if (this.drillLevel === 1) {
      this.showSourceLevelChart(clickedLabel);
    } else if (this.drillLevel === 2) {
      this.showDepartmentLevelChart(clickedLabel);
    }
  }
}

goBack() {
  if (this.drillLevel === 3) {
    this.showSourceLevelChart(this.selectedType);
  } else if (this.drillLevel === 2) {
    this.showTypeLevelChart();
  }
}

}
